import { createFileRoute } from "@tanstack/react-router";
import { MovementWishes } from "@/features/athlete";

/**
 * THE MOVEMENT FILTER — pushed from the deck's `Wishes · N` pill (frame `9c`).
 *
 * ⚠️ IT IS THE ATHLETE'S FEATURE AND NOT THE DECK'S, which the path deliberately does not say.
 * A wish is durable athlete state — `GET /v1/athlete` carries it, it survives a relaunch, and
 * the engine reads it on every draw — so the screen lives in `features/athlete`. What the URL
 * names is where an athlete thinks they are going: their wishes, reached from the deck.
 *
 * PUSHED AND NOT A SHEET: this is a list to walk, in four tabs, with a commitment at the end.
 */
export const Route = createFileRoute("/_app/wishes")({
  component: WishesScreen,
});

function WishesScreen() {
  return <MovementWishes />;
}
